import { UserCard } from "../../../../Users/shared/UserCard.js";
import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/User/Display.tsx
var UserFieldDisplay = ({ config }) => {
	const { valuesByFieldId } = useFormBuilderFieldsContext();
	const value = valuesByFieldId[config.id];
	if (!value) return null;
	return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col",
			children: [/* @__PURE__ */ jsxs(Label, { children: [config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {}), config.options.displayLabel] }), /* @__PURE__ */ jsx("div", {
				className: "py-xs",
				children: Array.isArray(value) ? /* @__PURE__ */ jsx("div", {
					className: "gap-xs inline-flex flex-wrap",
					children: value.map((userId, index) => /* @__PURE__ */ jsx(UserCard, { userId }, `${userId}/${index}`))
				}) : /* @__PURE__ */ jsx(UserCard, { userId: value })
			})]
		})
	});
};
//#endregion
export { UserFieldDisplay };

//# sourceMappingURL=Display.js.map